import PropTypes from 'prop-types';
import React from 'react';
import diff from 'object-diff';
import { bidStates } from '../../../core/api';
import { formalDate, fromNow, daysBetween } from '../../../core/date';
import BidSendModal from './BidSendModal';
import BidDetailTable from './BidDetailTable';
import BidDetailForm from './BidDetailForm';
import BidDetailNotes from './BidDetailNotes';
import DraftRenderer from '../../../components/DraftRenderer/DraftRenderer';
import moment from 'moment';
import { isValidPhoneNumber } from "react-phone-number-input";
import { construct } from 'core-js/fn/reflect';
import { note } from './BookingPropTypes';
import { Button } from 'react-bootstrap';
import BidDocuments from './BidDocuments';
import { host } from "../../../config";
import axios from 'axios';
import logo from '../../../../public/new.gif';

function getInitialValues(bid) {
  const nights = daysBetween(bid.bidset.event.end, bid.bidset.event.start);
  const initialValues = {
    hotel: {
      tax_rate: bid.hotel.tax_rate
        ? Number(bid.hotel.tax_rate * 100.0).toFixed(3)
        : bid.hotel.tax_rate,
      currency: bid.hotel.currency,
    },
    commission_rate: bid.commission_rate
      ? Number(bid.commission_rate * 100.0).toFixed(2)
      : bid.commission_rate,
    nights,
    additional_tax: bid.hotel.additional_tax
  };
  return initialValues;
}
function getUserDisplay(user) {
  if (user) {
    if (user.first_name) {
      return `${user.first_name} ${user.last_name}`;
    }
    return user.username;
  }
  return 'Unassigned';
}


const parsePercent = (value) => {
  if (!value || value.charAt(value.length - 1) === '.') return value;
  return typeof value === 'number' ? value : parseFloat(value.replace(/[^\d.]/g, ''));
};

function formatBrandNote(note){
  const noteList = [];
  if(note){
    note.forEach(val => {
      if(val.text){
        noteList.push(
          <div className="note">
            <p>{val.text}</p>
            <p className="text-muted">
              Added by {val.author.first_name} {val.author.last_name}
            </p>
          </div>
        )
      }
    });
    if(noteList.length != 0){
      return noteList;
    } else{
      return null;
    }
    
  } else{
    return null;
  }
}
function getCityNotes(data, city_id, citysData,cityname) {
  const cityNotes = []; // Array to store notes for each city
  let firstCityName
  if (cityname.includes(',')) {
    firstCityName = cityname;
    // Your code to execute if cityname can be split
  } else {
    firstCityName = cityname;
  }

  for (let i = 0; i < citysData.length; i++) {
    const city_id = citysData[i].bidset.event.parent;
    if (data.length > 0) {
      const notes = data.filter(itm => itm.city_id === city_id && itm.city_name === firstCityName);
      if (notes.length > 0 && notes[0].note_json && notes[0].note_json.blocks && notes[0].note_json.blocks[0] && notes[0].note_json.blocks[0].text) {
        return <DraftRenderer raw={notes[0].note_json} />
          // if (cityNotes.indexOf(notes[0].note_json.blocks[0].text) > -1) {
          //   //In the array!
          // } else {
          //   cityNotes.push(notes[0].note_json.blocks[0].text); // Add note to cityNotes array
          // }
        // cityNotes.push(notes[0].note_json.blocks[0].text); // Add note to cityNotes array
      } else {
        cityNotes.push(''); // Add an empty string if note text is not available
      }
    } else {
      cityNotes.push(''); // Add an empty string if data is empty
    }
  }

  return cityNotes; // Return all the notes for each city
}

class BidDetail extends React.Component {

  constructor(props) {
    super(props);
    const bid = props.bid
    let bidData = [];
    bid.bid_bid_details.map(c => {
      let data = bidData.find(bd => bd.check_in_date == c.bid_details.check_in_date && bd.check_out_date == c.bid_details.check_out_date && bd.room_type == c.bid_details.room_type)
      if (data) {
        data.no_of_Guest++
      } else {
        let insertObj = {
          room_type: c.bid_details.room_type,
          no_of_Guest: 1,
          check_in_date: c.bid_details.check_in_date,
          check_out_date: c.bid_details.check_out_date,
          rate_per_night: c.rate_per_night,
          room_category:c.room_category
        }
        // If room_type is 4 then it's NoHotel room
        if(insertObj.room_type !== 7){
          bidData.push(insertObj)
        }
        // bidData.push(insertObj)
      }
    })
    const bid_details_input = {
      tax_rate: bid.hotel.tax_rate
        ? Number(bid.hotel.tax_rate * 100.0).toFixed(3)
        : bid.hotel.tax_rate,

      commission_rate: bid.commission_rate
        ? Number(bid.commission_rate * 100.0).toFixed(2)
        : bid.commission_rate,
      bidData: bidData,
      currency: bid.hotel.currency,
      additional_tax: bid.hotel.additional_tax,
      name : bid.name,
      email : bid.email,
      contact :bid.phone_number
    }

    let sum = 0;
    bid_details_input.bidData.map(c => {
      const a = moment(c.check_out_date);
      const b = moment(c.check_in_date);
      sum += Number(c.no_of_Guest) * a.diff(b, 'days') * Number(c.rate_per_night)
    })

    sum += Number(bid_details_input.tax_rate / 100.0 || 0) * sum;
    bid_details_input.bidData.map(bid => {
      const check_out = moment(bid.check_out_date);
      const check_in = moment(bid.check_in_date);
      sum += Number(bid.no_of_Guest) * check_out.diff(check_in, 'days') * Number(bid_details_input.additional_tax)
    })    
    
    bid_details_input.total = parseFloat(sum).toFixed(2);

    const cellEditProp = {
      mode: 'click',
      blurToSave: true,
      beforeSaveCell: this.beforeSaveCell,
      afterSaveCell: this.onAfterSaveCell,
    };

    this.state = {
      showModal: false,
      edit: false,
      bid_details_input: bid_details_input,
      cellEditProp: cellEditProp,
      isValidRatePerNight: true,
      isDisabled:true,
      disabled:false,
      answers:this.props.answerData,
      notesData:this.props.notesData,
      bid_id:this.props.bid.id,
      answerData:false,
      bidDocPopUp:false,
      bidDocumentAddPopup:false,
      uploadedDocuments:[]
    };

    this.handleBidSubmit = this.handleBidSubmit.bind(this);
    this.displayBidAssignment = this.displayBidAssignment.bind(this);
    this.close = this.close.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleEditclose = this.handleEditclose.bind(this);
    this.handleAddAdditionalTax = this.handleAddAdditionalTax.bind(this);
  }
  componentDidMount() {
    const groupId = this.props.bid.tourgroup_id;
    const tourId= this.props.proposal.tour.id;
    const eventId= this.props.bid.bidset.event.parent;
    const bidderState = bidStates[this.props.bid.bidder_state];
    if (bidderState === 'Unread') {
      const payload = {};
      payload.bidder_state = 'VW';
      this.props.editBid(this.props.bid.id, payload);
    }
    this.props.requestBidDetails(this.props.bid.id)
    this.fetchDocuments(groupId,tourId,eventId)
  }

  fetchDocuments = (groupId,tourId,eventId) => {
    const auth = JSON.parse(sessionStorage.getItem('auth'));
    const tokenKey = auth.token;
    const upload_type = 'Tour Group'
    axios.get(`${host}/api/participants_documents/get_documents_by_tour/?tour_id=${tourId}&upload_type=${upload_type}&event_id=${eventId}&group_id=${groupId}`, {
        headers: {
            Authorization: `Token ${tokenKey}`,
        },
    })
        .then((response) => {
            this.setState({ uploadedDocuments: response.data });
        })
        .catch((error) => {
            console.error('Error fetching documents:', error);
        });
};


  buttonValue(){
   this.state.isDisabled=false;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.bid.bid_bid_details.length && (nextProps.bid.bid_bid_details.length != this.props.bid.bid_bid_details.length)) {
      const bid = nextProps.bid
      let bidData = []
      bid.bid_bid_details.map(c => {
        let data = bidData.find(bd => bd.check_in_date == c.bid_details.check_in_date && bd.check_out_date == c.bid_details.check_out_date && bd.room_type == c.bid_details.room_type)
        if (data) {
          data.no_of_Guest++
        } else {
          let insertObj = {
            room_type: c.bid_details.room_type,
            no_of_Guest: 1,
            check_in_date: c.bid_details.check_in_date,
            check_out_date: c.bid_details.check_out_date,
            rate_per_night: c.rate_per_night,
            room_category:c.room_category
          }
          // If room_type is 4 then it's NoHotel room
          if(insertObj.room_type !== 7){
            bidData.push(insertObj)
          }
          // bidData.push(insertObj)
        }
      })
      const bid_details_input = {
        tax_rate: bid.hotel.tax_rate
          ? Number(bid.hotel.tax_rate * 100.0).toFixed(3)
          : bid.hotel.tax_rate,

        commission_rate: bid.commission_rate
          ? Number(bid.commission_rate * 100.0).toFixed(2)
          : bid.commission_rate,
        bidData: bidData,
        currency: bid.hotel.currency,
        additional_tax: bid.hotel.additional_tax,
        // resort_fee: bid.hotel.resort_fee
        // getting resort_fee from bid instead of bid.hotel
        resort_fee: bid.resort_fee,
        name : bid.name,
        email : bid.email,
        contact :bid.phone_number
      }

      let sum = 0;
      bid_details_input.bidData.map(c => {
        const a = moment(c.check_out_date);
        const b = moment(c.check_in_date);
        sum += Number(c.no_of_Guest) * a.diff(b, 'days') * Number(c.rate_per_night)
      })

      sum += Number(bid_details_input.tax_rate / 100.0 || 0) * sum;
      sum += this.handleAddAdditionalTax(bid_details_input);
      bid_details_input.total = parseFloat(sum).toFixed(2);

      this.setState({
        bid_details_input
      });
    }
  }

  handleBidSubmit(values) {
    let payload = this.state.answers;    
    this.props.addAnswers(payload,(response) => {
      if(response){
        this.getAnswers();
      }
    });
    if(this.state.bid_details_input.name){
      if(this.state.bid_details_input.email){
        if (this.state.bid_details_input.contact){
          let value = isValidPhoneNumber(this.state.bid_details_input.contact)
          if(value==true){
            this.state.isDisabled=true;
            const initialValues = getInitialValues(this.props.bid)
            if (initialValues.hotel) {
              initialValues.hotel.tax_rate = Number(this.state.bid_details_input.tax_rate / 100.0).toFixed(6);
              initialValues.hotel.additional_tax = Number(this.state.bid_details_input.additional_tax);
              initialValues.hotel.currency = this.state.bid_details_input.currency;
            }
            if (initialValues.commission_rate) {
              initialValues.commission_rate = Number(this.state.bid_details_input.commission_rate / 100.0).toFixed(3);
            }

            initialValues.resort_fee = Number(this.state.bid_details_input.resort_fee)
            initialValues.currency = this.state.bid_details_input.currency
            initialValues.hotel.currency = this.state.bid_details_input.currency
            if (values.note) {
              initialValues.note = values.note;
            }

            initialValues.name = this.state.bid_details_input.name;
            initialValues.email = this.state.bid_details_input.email;
            initialValues.contact = this.state.bid_details_input.contact;


            initialValues.bidder_state = 'RE';
            initialValues.bidder = { id: this.props.user.id };


            initialValues.bid_details_request = this.state.bid_details_input.bidData.map(c => {
              return this.saveBidDetails(c)
            })

            const payload = diff(getInitialValues(this.props.bid), initialValues);
            // Check is there any invalid bid request with invalid rate_per_night
            const inValidBidDetailsRequest = payload.bid_details_request.filter(x => x.rate_per_night == null || x.rate_per_night == 0 || x.rate_per_night == '');
    
            if(inValidBidDetailsRequest.length > 0){
              this.setState({
                isValidRatePerNight: false
              });
            }else{
              this.setState({
                isValidRatePerNight: true
              });

            this.props.editBid(this.props.bid.id, payload);
            this.setState({ edit: false });
            }
          } else{
            alert("Invalid phone number")
          }
        } else{
          alert("Phone number is required")
        }
      } else{
        alert("Email is required")
      }
    }else{
      alert("Name is required")
    }
  }
  getAnswers(){
    let pk = this.props.bid.id;
    let answersData = [];
    this.props.requestAnswers(pk, (response) =>{
      if(this.props.addedanswers.answers){
        this.props.addedanswers.answers.forEach((answer) => {
          if(pk == answer.bid_id){
            answersData.push({
              id: answer.id,
              bid_id: answer.bid_id,
              question: answer.question,
              answer: answer.answer,
              group_id: answer.group_id,
              tour_id: answer.tour_id
            })
          }

        });
        this.setState({
          answers: answersData,
        })
      } else{
        alert("answers data is not avaiable")
      }
    });
  }

  close() {
    this.setState({ showModal: false });
  }
  handleEdit() {
    this.setState({ edit: true });
  }
  handleEditclose(){
    this.resetValues();
    this.setState({ edit: false });
  }
  displayBidAssignment() {
    this.setState({ showModal: true });
  }

  onPhoneNoChange = (e) =>{
    this.buttonValue();
    var bid_details_input = { ...this.state.bid_details_input }
    bid_details_input.contact = e;
    this.setState({
      bid_details_input
    })
  }

  onDetailsChange = (e, type) =>{
    this.buttonValue();
    var bid_details_input = { ...this.state.bid_details_input }
    bid_details_input[type] = e.target.value;

    this.setState({
      bid_details_input
    })
  }
  onAnswerChange = (e,q) => {
    this.buttonValue();
    let ansVal = this.state.answers;
    ansVal.map((data) =>{
      if(q.question==data.question){
        data.answer = e.target.value;
      } else{
        console.log("question data is not matched")
      }
    })
    this.setState({
      answers:ansVal,
    })
  }

  resetValues =() => {
    this.getAnswers();
    const bid = this.props.bid;
    let bidData = []
    bid.bid_bid_details.map(c => {
      let data = bidData.find(bd => bd.check_in_date == c.bid_details.check_in_date && bd.check_out_date == c.bid_details.check_out_date && bd.room_type == c.bid_details.room_type)
      if (data) {
        data.no_of_Guest++
      } else {
        let insertObj = {
          room_type: c.bid_details.room_type,
          no_of_Guest: 1,
          check_in_date: c.bid_details.check_in_date,
          check_out_date: c.bid_details.check_out_date,
          rate_per_night: c.rate_per_night,
          room_category: c.room_category
        }
        if(insertObj.room_type !== 7){
          bidData.push(insertObj)
        }
      }
    })
    var bid_details_input = { ...this.state.bid_details_input }
    bid_details_input.tax_rate = bid.hotel.tax_rate? Number(bid.hotel.tax_rate * 100.0).toFixed(3): bid.hotel.tax_rate;
    bid_details_input.commission_rate = bid.commission_rate? Number(bid.commission_rate * 100.0).toFixed(3): bid.commission_rate;
    bid_details_input.currency = bid.hotel.currency;
    bid_details_input.additional_tax = bid.hotel.additional_tax;
    bid_details_input.resort_fee = bid.resort_fee;
    bid_details_input.bidData = bidData;
    bid_details_input.name = bid.name;
    bid_details_input.email = bid.email;
    bid_details_input.contact = bid.phone_number;

    let sum = 0;
    bid_details_input.bidData.map(c => {
      const a = moment(c.check_out_date);
      const b = moment(c.check_in_date);
      sum += Number(c.no_of_Guest) * a.diff(b, 'days') * Number(c.rate_per_night)
    })

    sum += Number(bid_details_input.tax_rate / 100.0 || 0) * sum;
    sum += this.handleAddAdditionalTax(bid_details_input);
    bid_details_input.total = parseFloat(sum).toFixed(2);

    this.setState({
      bid_details_input
    })
  }
  onRateChange = (e, type) => {
    this.buttonValue();
    var bid_details_input = { ...this.state.bid_details_input }
    bid_details_input[type] = e.target.value

    let sum = 0;
    bid_details_input.bidData.map(c => {
      const a = moment(c.check_out_date);
      const b = moment(c.check_in_date);
      sum += Number(c.no_of_Guest) * a.diff(b, 'days') * Number(c.rate_per_night)
    })

    sum += Number(bid_details_input.tax_rate / 100.0 || 0) * sum;
    sum += this.handleAddAdditionalTax(bid_details_input);
    bid_details_input.total = parseFloat(sum).toFixed(2);

    this.setState({
      bid_details_input
    })
  }

  onCurrencyChange = (e) => {
    this.buttonValue();
    if (e) {
      const bid_details_input = { ...this.state.bid_details_input }
      bid_details_input.currency = e.value
      bid_details_input.currency = e.value

      this.setState({
        bid_details_input
      })
    }
  }
  beforeSaveCell = (row, cellName,cellValue) => {
    if(cellName=='rate_per_night'){
      let value = Math.sign(cellValue)
      if(value==-1){
        alert('Please enter valid "Rate per night" value.')
      }
      
    }
  }
  bidDocumentShow=()=>{
    this.setState({bidDocPopUp:true})
  }
  onClose=()=>{
    this.setState({bidDocPopUp:false})
  }

  bidDocumentAdd=()=>{
    this.setState({bidDocumentAddPopup:true})
  }
  onCloseBid=()=>{
    this.setState({bidDocumentAddPopup:false})
  }
  onAfterSaveCell = (row, cellName, cellValue) => {
    this.buttonValue();
    var bid_details_input = { ...this.state.bid_details_input }
    let sum = 0;
    bid_details_input.bidData.map(c => {
      let value = Math.sign(c.rate_per_night);
      if(value != -1){
        const a = moment(c.check_out_date);
        const b = moment(c.check_in_date);
        sum += Number(c.no_of_Guest) * a.diff(b, 'days') * Number(c.rate_per_night)
      } else{
        c.rate_per_night='';
      }
    })
    sum += Number(bid_details_input.tax_rate / 100.0 || 0) * sum;
    sum += this.handleAddAdditionalTax(bid_details_input);
    bid_details_input.total = parseFloat(sum).toFixed(2);
    this.setState({
      bid_details_input
    })
  }

  handleAddAdditionalTax(bidDetail){
    let sum = 0;
    bidDetail.bidData.map(bid => {
      const check_out = moment(bid.check_out_date);
      const check_in = moment(bid.check_in_date);
      if(bid.rate_per_night){
        if (Number(bidDetail.resort_fee) == 0){
          sum += Number(bid.no_of_Guest) * check_out.diff(check_in, 'days') * Number(bidDetail.additional_tax)
        }
        if (Number(bidDetail.additional_tax) ==0){
          sum += Number(bid.no_of_Guest) * check_out.diff(check_in, 'days') * Number(bidDetail.resort_fee)
        }
        if (Number(bidDetail.additional_tax) != 0 && Number(bidDetail.resort_fee) != 0){
          sum += Number(bid.no_of_Guest) * check_out.diff(check_in, 'days') * (Number(bidDetail.additional_tax))
          sum += Number(bid.no_of_Guest) * check_out.diff(check_in, 'days') * (Number(bidDetail.resort_fee))
        }

        
     }
    })
    return sum;
  }

  saveBidDetails = (data) => {
    const bid_details_ids = this.props.bid.bid_bid_details.filter(o => o.bid_details.check_in_date == data.check_in_date &&
      o.bid_details.check_out_date == data.check_out_date &&
      o.bid_details.room_type == data.room_type).map(c => {
        return c.id;
      });
    const obj = {
      rate_per_night: data.rate_per_night,
      ids: bid_details_ids,
      bid_id: this.props.bid.id,
      room_category:data.room_category
    }
    return obj
    // this.props.saveBidDetailsRates(obj)
  }

  render() {
    const getAvailableBids = this.props.proposal.bids.filter((item)=>{
      if(item.bidset){
        return item
      }
    })
    const city_id = getAvailableBids[0].bidset.event.parent
    const {city_notes} = this.props.proposal.tour
    const { bid } = this.props;
    const eventData = this.props.proposal.tour.tour_stops
    let event_id
    const city_data=eventData.filter((data)=>{
      if (data.place.name === bid.bidset.event.place.name)
      {
        return data
      }
    })
    try{
      event_id=city_data[0].id
    }
    catch(error){
      console.log('error got in Booking/BidDetail.js')
      event_id=null
    }
    

    const checkinDate = bid.bid_bid_details.length>0?bid.bid_bid_details[0].bid_details.lowest_check_in_date:null
    const checkoutDate = bid.bid_bid_details.length>0?bid.bid_bid_details[0].bid_details.greatest_check_out_date:null
    let cityname
    try {
      cityname = bid.bidset.event.place.name
      // cityname = bid.bidset.event.place.city === null ? bid.bidset.event.place.name : bid.bidset.event.place.city;
  } catch (error) {
      // Handle the error gracefully
      console.error("An error occurred while accessing city information:", error);
      // You can provide a default value or handle the error in an appropriate way
      cityname = 'unknown';
  }
    const cityNotes = getCityNotes(city_notes,city_id, getAvailableBids ,cityname);
    const brandNoteList = formatBrandNote(this.state.notesData);
    const style = {fontSize:'18px'};
    const bidderState = bidStates[bid.bidder_state];
    const isNew = bidderState === 'Unread' || bidderState === 'Viewed';
    const canEdit =
      bidderState === 'Unread' || bidderState === 'Viewed' || bidderState === 'Replied' || bidderState === 'Unsent' || bidderState === 'Soldout';
    let isValidRatePerNight = this.state.isValidRatePerNight;

    // let bid_details = this.props.bid.bid_details.filter(o => o.bid_id == this.props.bid.id);

    let bidData = []
    this.props.bid.bid_bid_details.map(c => {

      let data = bidData.find(bd => bd.check_in_date == c.bid_details.check_in_date && bd.check_out_date == c.bid_details.check_out_date && bd.room_type == c.bid_details.room_type)
      if (data) {
        data.no_of_Guest++
      } else {
        let insertObj = {
          room_type: c.bid_details.room_type,
          no_of_Guest: 1,
          check_in_date: c.bid_details.check_in_date,
          check_out_date: c.bid_details.check_out_date,
          rate_per_night: c.rate_per_night,
          room_category:c.room_category
        }
        // If room_type is 4 then it's NoHotel room
        if(insertObj.room_type !== 7){
          bidData.push(insertObj)
        }
        // bidData.push(insertObj)
      }
    })

    // Check is there any invalid bid request with invalid rate_per_night
    const inValidBidDetailsRequest = this.state.bid_details_input.bidData.filter(x => x.rate_per_night == null || x.rate_per_night == 0 || x.rate_per_night == '');
    if(inValidBidDetailsRequest.length > 0){
      isValidRatePerNight = false ;
    }else{
      isValidRatePerNight = true ;
    }

    let bidDetail;
    if (isNew || this.state.edit) {
      bidDetail = (
        <BidDetailForm
          profilename={this.props.profilename}
          initialValues={getInitialValues(this.props.bid)}
          tour={this.props.proposal.tour}
          bid={this.props.bid}
          bid_details_input={this.state.bid_details_input}
          displayBidAssignment={this.displayBidAssignment}
          editBid={this.props.editBid}
          onSubmit={this.handleBidSubmit}
          isNew={isNew}
          onRateChange={this.onRateChange}
          onDetailsChange={this.onDetailsChange}
          onAnswerChange={this.onAnswerChange}
          onPhoneNoChange={this.onPhoneNoChange}
          resetValues={this.resetValues}
          cellEditProp={this.state.cellEditProp}
          onCurrencyChange={this.onCurrencyChange}
          isValidRatePerNight={this.state.isValidRatePerNight}
          isDisabled={this.state.isDisabled}
          disabled={this.state.disabled}
          handleEditclose={this.handleEditclose}
          addedanswers={this.state.answers}
        />
      );
    } else {
      bidDetail = (
        <BidDetailTable
          bid={this.props.bid}
          displayBidAssignment={this.displayBidAssignment}
          editBid={this.props.editBid}
          canEdit={canEdit}
          bidData={bidData}
          handleEdit={this.handleEdit}
          total={this.state.bid_details_input.total}
          addedanswers={this.state.answers}
        />
      );
    }
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div style={{display:'flex'}} >
              <h4>{bid.hotel.name}</h4>
              <div style={{marginLeft:'39%'}} >
                  <Button bsStyle="success formbtn" bsSize="small" onClick={this.bidDocumentShow} >View Hotel Documents</Button>
                  {this.state.uploadedDocuments.length >=1&&(
                   <img style={{width:bidderState=='Accepted'?'7%':'11%',marginBottom:'20px'}} className="sidebar-img" src={logo} alt="CATCH" />
                  )}
                  {bidderState=='Accepted' &&(
                    <Button bsStyle="info formbtn" bsSize="small" onClick={this.bidDocumentAdd} >Add Bid Document</Button>
                  )}
            
              </div>
            </div>
            <p>
              <i className="fa fa-map-marker" />
              {bid.hotel.address}, {bid.hotel.locality}, {bid.hotel.region} {bid.hotel.postcode}
            </p>
            <p>
              {formalDate(checkinDate?checkinDate:bid.bidset.event.start)} -
              {formalDate(checkoutDate?checkoutDate:bid.bidset.event.end)}
            </p>
            {bid.bidder && <p>Bidder: {getUserDisplay(bid.bidder)}</p>}
            {bid.buyer && <p>Requestor: {getUserDisplay(bid.buyer)}</p>}
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-12">
            {brandNoteList?(
              <div>
                <span style={style}> Brand Manager Note</span>
                <span className="note-list">{brandNoteList}</span><hr/>
              </div>
              ):('')}
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12' style={{border:'0.5px solid rgb(216 214 214)',borderRadius:'6px',marginBottom:'11px'}}>
            <span style={style} > City Info </span>
            <div style={{margin:'2px 0px 25px 1px'}} >
              {cityNotes}
            </div>
          </div>
          <div className='col-md-12'  style={{border:'0.5px solid rgb(216 214 214)',borderRadius:'6px',marginBottom:'11px'}} >
            <span style={style}>Bid Info</span>
            {this.props.bid.bidset.event.group_note && (
              <div>{this.props.bid.bidset.event.group_note}</div>
            )}
            {this.props.bid.bidset.event.group_note_json && (
              <div>
                <DraftRenderer raw={this.props.bid.bidset.event.group_note_json} />
              </div>
            )}
            </div>
        </div>
        <div className="row">
          <div className="col-md-12">  
            <div>
              Status: <strong>{bidderState}</strong>
              <br />
              <br />
              <p>
                {bid.sent_on && <span>Send Date: {fromNow(bid.sent_on)}</span>}
                <br />
                {bid.replied_on && (
                  <span>Reply Date: {bid.replied_on && fromNow(bid.replied_on)}</span>
                )}<br />
                {bid.name && (
                <span>Replied By: {bid.name?bid.name:''} ({bid.email?bid.email:''}) {bid.phone_number?bid.phone_number:''}</span>)}
              </p>
            </div>
          </div>
        </div>

        {bidDetail}

        <div className="row">
          <div className="col-md-12">
            <BidDetailNotes bid={this.props.bid} notesData={this.state.notesData} editBid={this.props.editBid} isNew={isNew} />
          </div>
        </div>
        {this.state.showModal && (
          <BidSendModal
            bid={this.props.bid}
            close={this.close}
            show={this.state.showModal}
            sendBid={this.props.sendBid}
            intialValues={this.props.bid}
            updateHotelContacts={this.props.updateHotelContacts}
            deleteHotelContacts={this.props.deleteHotelContacts}
            user={this.props.user}
          />
        )}
        {this.state.bidDocPopUp && (
          <BidDocuments
            city_id={event_id} 
            tour={this.props.proposal.tour}
            group_id ={this.props.bid.tourgroup_id}
            // bid={this.props.bid}
            upload_type={'Tour Group'}
            show={this.state.bidDocPopUp}
            onClose={()=>this.onClose()}
          />
        )}
        {this.state.bidDocumentAddPopup &&(
           <BidDocuments
            bid={this.props.bid}
            tourp={this.props.profilename}
            tour={this.props.proposal.tour}
            upload_type={'Bid Response'}
            show={this.state.bidDocumentAddPopup}
            onClose={()=>this.onCloseBid()}
         />
        )}
      </div>
    );
  }
}

BidDetail.propTypes = {
  bid: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  editBid: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
};

export default BidDetail;



// WEBPACK FOOTER //
// src/routes/booking/components/BidDetail.js